// API functions for authentication
// Use a relative base so dev server proxy (package.json "proxy") works from LAN/mobile
const BASE_URL = "/api";

export const apiLogin = async (idPengguna, katalaluan) => {
  try {
    const response = await fetch(`${BASE_URL}/auth/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({
        id_pengguna: idPengguna,
        katalaluan: katalaluan,
      }),
    });

    if (!response.ok) {
      throw new Error("Login failed");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Login error:", error);
    throw error;
  }
};

export const apiLogout = async () => {
  try {
    // Call backend to destroy session
    await fetch(`${BASE_URL}/auth/logout`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    });
    // Remove client-side cache
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    return true;
  } catch (error) {
    console.error("Logout error:", error);
    throw error;
  }
};

export const getCurrentUser = () => {
  try {
    const userString = localStorage.getItem("user");
    return userString ? JSON.parse(userString) : null;
  } catch (error) {
    console.error("Get current user error:", error);
    return null;
  }
};

export const setUserData = (userData) => {
  try {
    // Normalize: ensure bahagian is present if backend returns bahagian_pemantau
    const normalized = { ...userData };
    if (!normalized.bahagian) {
      normalized.bahagian =
        normalized.bahagian_pemantau || normalized.department || normalized.dept || normalized.dep || "";
    }
    localStorage.setItem("user", JSON.stringify(normalized));
    if (userData.token) {
      localStorage.setItem("token", userData.token);
    }
  } catch (error) {
    console.error("Set user data error:", error);
  }
};
